import ReservationTotal from 'Checkout/Components/ReservationDetails/ReservationTotal/ReservationTotal'
import Reservations from 'Checkout/Components/Shared/CartSummary/Reservations'
import { useReservationsEffect } from 'Checkout/Hooks/useReservationsEffect'
import { useReservationsPricing } from 'Checkout/Hooks/useReservationsPricing'

const CartSummary = () => {
  const fetchPrice = useReservationsPricing()

  useReservationsEffect(() => {
    fetchPrice()
  })

 return (
    <div className="cart-summary bg-white border border-2 p-3 rounded">
      <span className="text-muted text-uppercase">Cart Summary</span>

      <hr />

      <Reservations hideError />

      <ReservationTotal />
    </div>
  )
}

export default CartSummary
